import React, { useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';
export const ScalpelUI = (props: UIProperties<ScalpelUIConfig>) => {
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',  
			width: '100%',
			height: '100%',
			pointerEvents: 'none'
		}}>
			<div style={{
				position: 'absolute',
				top: '300px',
				left: '600px',
				width: '380px',
				height: '240px',
				pointerEvents: 'all',
				border: '3px solid rgb(192, 161, 6)',
				backgroundColor: 'rgb(36, 36, 36)'
			}}>
				<div style={{
					width: '100%',
					height: '240px',
					position: 'relative',
					top: '0',
					left: '0'
				}}>

					<CustomScalpelButton 
						position={{
							type: 'relative',
							left: '20px',
							top: '20px'
						}}
						id='cric-scalpel-ui-top'
						isDisabled={false}
						text='Remove Scalpel'
						onClicked={() => {
							props.parameters.onRemoveScalpelClicked();
						}}
					/>
					<CustomScalpelButton 
						position={{
							type: 'relative',
							left: '20px',
							top: '20px'
						}}
						id='cric-scalpel-ui-bottom'
						isDisabled={false}
						text='Keep scalpel in place'
						onClicked={() => {
							props.parameters.onKeepScalpelInPlaceClicked();
						}}
					/>
				</div>
			</div>
		</div>
	)
}

const CustomScalpelButton = (props: CustomScalpelButtonConfig) => {
	return (
		<div style={{
			position: props.position.type ? props.position.type : 'relative',
			top: props.position.top,
			left: props.position.left,
			width: '340px',
			height: '95px',
			pointerEvents: 'none'
		}}>
			<div style={{
				position: 'relative'
			}}>
				<GeneralButtonWithText parameters= {{
					text: '',
					ariaLbl: props.text,
					id: props.id,
					top: '0px',
					left: '0px',
					isDisabled: props.isDisabled,
					width: '330px',
					srcIdle: './assets/images/main-menu/button_menu_exit.png',
					srcHighlight: './assets/images/main-menu/button_menu_exit_down.png',
					srcDisabled: null,
					customMainStyle: {
						position: 'relative',
						width: '100%',
						height: '90px'
					},
					customButtonStyle: {
						width: '100%',
						height: '90px'
					},
					customImgStyle: {
						width: '100%',
						height: '90px'
					},
					onClicked: () => {
						if(props.onClicked) {
							props.onClicked();
						}
					}
				}}/>
				
				<div style={{
					position: 'absolute',
					height: '30px',
					pointerEvents: 'none',
					width: '100%',
					left: '0',
					top: '50%',
					transform: 'translate(0, -50%)'
				}}>
					<div style={{
						position: 'relative',
						top: '50%',
						transform: 'translate(0, -50%)'
					}}>
						<p className='title-font' style={{
							textAlign: 'center',
							margin: '0',
							fontSize: '16pt',
							fontWeight: 'normal'
						}}>{props.text}</p>
					</div>
					
				</div>
			</div>
		</div>
	);

};

interface CustomScalpelButtonConfig {
	text: string;
	id: string;
	isDisabled: boolean;
	position: CustomScalpelButtonPosition;
	onClicked?: () => void;
}

interface CustomScalpelButtonPosition {
	type?: any;
	left: string;
	top: string;
}
	
export interface ScalpelUIConfig extends BaseConfig{
	onRemoveScalpelClicked: () => void;
	onKeepScalpelInPlaceClicked: () => void;
}